import React, { useState, useEffect, useCallback } from 'react';
import API from '../services/api';
import Modal from '../components/Modal';

const bugun = () => { const d = new Date(); const p = n => String(n).padStart(2,'0'); return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}`; };
const trTarih = s => s ? new Date(s).toLocaleDateString('tr-TR') : '—';
const trTutar = v => (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 });

const TUR_RENK = {
  'Nakit': { bg:'#e7f0ff', fg:'#2563c9' },
  'Banka': { bg:'#fff0e6', fg:'#c2570a' },
  'Çek':   { bg:'#fdf6e0', fg:'#9a7d00' },
};

export default function Odemeler() {
  const [bas, setBas] = useState(bugun());
  const [bit, setBit] = useState(bugun());
  const [data, setData] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modal, setModal] = useState(null);
  const [modalYukleniyor, setModalYukleniyor] = useState(false);

  const yukle = useCallback((b, s) => {
    setYukleniyor(true);
    API.get('/Finans/odemeler', { params: { bas: b, bit: s } })
      .then(r => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setYukleniyor(false));
  }, []);

  useEffect(() => { yukle(bas, bit); }, []); // eslint-disable-line

  const turBadge = tur => {
    const c = TUR_RENK[tur] || { bg:'#eef0f4', fg:'#6b7280' };
    return <span className="rozet" style={{ background:c.bg, color:c.fg }}>{tur}</span>;
  };

  return (
    <div>
      <h1 className="sayfa-baslik">Ödemeler</h1>
      <p className="sayfa-alt">Dönemsel ödeme listesi.</p>

      <form onSubmit={e => { e.preventDefault(); yukle(bas, bit); }}
            style={{ display:'flex', gap:12, alignItems:'flex-end', flexWrap:'wrap', marginBottom:18 }}>
        <div className="form-row"><div className="form-label">Başlangıç</div>
          <input type="date" className="input" value={bas} onChange={e => setBas(e.target.value)} /></div>
        <div className="form-row"><div className="form-label">Bitiş</div>
          <input type="date" className="input" value={bit} onChange={e => setBit(e.target.value)} /></div>
        <button className="btn" type="submit">Listele</button>
      </form>

      {!yukleniyor && data && (
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', marginBottom:14 }}>
          <span className="bilgi-rozet">💸 {data.liste.length} kayıt</span>
          <span className="bilgi-rozet" style={{ fontWeight:700 }}>Toplam: {trTutar(data.toplam)} ₺</span>
        </div>
      )}

      <div className="kart" style={{ overflow:'hidden' }}>
        {yukleniyor ? <div className="bos-durum">Yükleniyor…</div>
          : !data || data.liste.length === 0 ? <div className="bos-durum">Bu dönemde ödeme bulunamadı.</div>
          : (
          <table className="tablo">
            <thead><tr>
              <th style={{ width:110 }}>Tarih</th>
              <th>Kime</th>
              <th style={{ width:100 }}>Tür</th>
              <th style={{ width:140, textAlign:'right' }}>Tutar</th>
            </tr></thead>
            <tbody>
              {data.liste.map((r, i) => (
                <tr key={i} onClick={async () => {
                  setModalYukleniyor(true);
                  try {
                    const res = await API.get(`/Finans/chi/${r.id}`);
                    setModal(res.data);
                  } catch {
                    setModal(r);
                  } finally {
                    setModalYukleniyor(false);
                  }
                }} style={{ cursor:'pointer' }}>
                  <td>{trTarih(r.tar)}</td>
                  <td style={{ fontWeight:600 }}>{r.unvan || '—'}</td>
                  <td>{turBadge(r.tur)}</td>
                  <td style={{ textAlign:'right', fontWeight:600 }}>{trTutar(r.tutar)} ₺</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modal && (
        <Modal baslik="Ödeme Detayı" onKapat={() => setModal(null)}>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            <div><strong>Tarih:</strong> {trTarih(modal.tar)}</div>
            <div><strong>Kime:</strong> {modal.unvan || '—'}</div>
            <div><strong>Tür:</strong> {modal.tur}</div>
            <div><strong>Tutar:</strong> {trTutar(modal.tutar)} ₺</div>
          </div>
        </Modal>
      )}
    </div>
  );
}
